import
  React, {
  useContext
} from 'react';

import
  PropTypes
from 'prop-types';

import {
  Environment
} from '@vodacom/web-env';

import {
  HContainer,
  HContainerV,
  Image,
  Text,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  DaysOfTheWeek,
  ErrorKeys,
  FeatureToggles,
  Icons
} from '../../../constants';

import {
  SecondaryButton
} from 'components';

import {
  getStorageWithExpiry,
  isFeatureEnabled,
  setStorageWithExpiry
} from 'helpers';

import {
  AppContext
} from 'context';

import {
  WeatherProvider
} from 'journeys';

import {
  HandleRender
} from 'hocs';

export const WeatherWidget = props => {

  const { config } = useContext(AppContext);
  const [ weatherState, setWeatherState ] = React.useState({
    weather: null,
    weatherIcon:null,
    temperature: null,
    weekDay: DaysOfTheWeek[new Date().getDay()],
    city: getStorageWithExpiry('Location', 'city', Environment.current.cities?.[3].name),
    latitude: getStorageWithExpiry('Location', 'latitude', Environment.current.cities?.[3].latitude),
    longitude: getStorageWithExpiry('Location', 'longitude', Environment.current.cities?.[3].longitude),
    hasError: false,
    loading: true,
    error: null
  });

  React.useEffect(() => {
    const init = async () => {
      if (isFeatureEnabled(config, FeatureToggles.EnableWeather)) {

        await getWeather(weatherState?.city, weatherState?.latitude, weatherState?.longitude);
      }
    };

    init();
  }, [ props.coords ]);

  const getWeather = async (city, lat, lon) => {

    const cacheKey = `weather--${city || `${lat},${lon}`}`;

    const weather = await WeatherProvider.getCachedItem(
      cacheKey,
      null,
      () => WeatherProvider.getWeather(city, lat, lon)
    );

    if (!weather?.ok) {

      setWeatherState(prevState => ({
        ...prevState,
        hasError: true,
        loading: false,
        error: weather?.error
      }));

      return;
    }

    setStorageWithExpiry('Location', 'city', weather?.result?.city);
    setStorageWithExpiry('Location', 'latitude', weather?.result?.coord?.lat);
    setStorageWithExpiry('Location', 'longitude', weather?.result?.coord?.lon);

    setWeatherState(prevState => ({
      ...prevState,
      weather: weather?.result,
      weatherIcon:`${Environment.current.assetPath}images/icons/weather/${weather?.result?.weather?.[0]?.icon}.svg`,
      temperature:Math.floor(weather?.result?.main?.temp).toString(),
      city: weather?.result?.city,
      latitude: weather?.result?.coord?.lat || lat,
      longitude: weather?.result?.coord?.lon || lon,
      loading: false
    }));
  };

  return (

    <>
    {
      isFeatureEnabled(config, FeatureToggles.EnableWeather) &&

      <HandleRender
        isLoading={weatherState.loading}
        isError={weatherState.hasError}
        error={{ type: ErrorKeys.Empty }}
        loader={{ size: '100' }}>

        <VContainerVH
          boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
          borderRadius={'4px'}
          padding={'22px 5px 16px'}>

            <Text
              fontSize={'16px'}
              fontWeight={'bold'}
              textAlign={'center'}>

              {weatherState.city}
            </Text>

            <HContainerV
              width={'100%'}
              maxWidth={'375px'}
              margin={'10px 0 0'}
              justifyContent={'space-around'}>

              <HContainer>

                <Text
                  fontSize={'48px'}
                  fontWeight={'bold'}>

                  {`${weatherState.temperature}`}
                </Text>

                <Text
                  fontSize={'12px'}
                  fontWeight={'bold'}
                  padding={'5px 0 0'}>

                  {'o'}
                </Text>

                <Text
                  fontSize={'20px'}
                  fontWeight={'bold'}
                  padding={'5px 0 0'}>

                  {'C'}
                </Text>

              </HContainer>

                <Text
                  fontSize={'16px'}>

                  {weatherState.weekDay}
                </Text>

                {
                  weatherState.weatherIcon &&
                  <Image
                    src={weatherState.weatherIcon}
                    width={'70px'}
                    height={'70px'}
                    margin={'0 6px 0 0'}/>
                }

            </HContainerV>

            <SecondaryButton
              width={'200px'}
              margin={'16px 0 0'}
              text={'See more'}
              onClick={props.onClick}/>

        </VContainerVH>
      </HandleRender>
    }
    </>
  );
};

WeatherWidget.propTypes = {
  city: PropTypes.string,
  temperature: PropTypes.string,
  weekDay: PropTypes.string,
  weatherIcon: PropTypes.string,
  onClick: PropTypes.func
};

WeatherWidget.defaultProps = {
  city: 'Pretoria',
  temperature: '18',
  weekDay: 'Friday',
  weatherIcon: Icons.Lightning,
  onClick: () => {}
};
